import axiosClient from '../axiosClient';

export const getStaff = (params) =>
  axiosClient.get('/admin/staff', { params });

export const getStaffMember = (id) =>
  axiosClient.get(`/admin/staff/${id}`);

export const createStaffMember = (data) =>
  axiosClient.post('/admin/staff', data);

export const updateStaffMember = (id, data) =>
  axiosClient.put(`/admin/staff/${id}`, data);

export const deleteStaffMember = (id) =>
  axiosClient.delete(`/admin/staff/${id}`);
